module.exports = __webpack_public_path__ + "static/media/S (39).7474bbe8.jpg";